"use client";

import dynamic from "next/dynamic";

export const MarketingAnalyticsLoader = dynamic(
  () =>
    import("./MarketingAnalytics").then((module) => module.MarketingAnalytics),
  { ssr: false },
);
